module.exports = __webpack_public_path__ + "media/images/japan_heritage_background_image-7bf9ff4cd394a89d9cfed90c0c1ade88.jpeg";